class ScrollListElement extends HTMLElement {
  connectedCallback() {
    addEventListener("scroll", this, { passive: true });
    this.update();
  }

  disconnectedCallback() {
    removeEventListener("scroll", this, { passive: true });
  }

  handleEvent(e) {
    if (e.type === "scroll") {
      this.update();
    }
  }

  update() {
    let d = Infinity;
    let best = null;
    let cy = 0.5 * innerHeight;
    const items = Array.from(this.querySelectorAll("h3, li"));
    for (const item of items) {
      const r = item.getBoundingClientRect();
      const y = r.y + 0.5 * r.height;
      const d1 = Math.abs(y - cy);
      if (d1 < d) {
        d = d1;
        best = item;
      }
    }
    this.toggleAttribute("data-active", d < innerHeight * 0.2);
    if (this._best === best) return;
    this._best = best;
    for (const item of items) {
      item.classList.toggle("active", item === best);
    }
    document.querySelector("pip-container").replaceChildren(best.querySelector("template").content.cloneNode(true));
  }
}

customElements.define("scroll-list", ScrollListElement);
